export default __webpack_public_path__ + "src/images/packages/kosi-forest-lodge/1f648f24eedda065de397226c9bf9bdc-2.jpg";